













import { defineComponent, PropType, ref, toRefs } from '@nuxtjs/composition-api'

import useFilterBarItem from '@/composables/use-filter-bar-item'
import { tdCarFilterPc } from '@/modules/ga4'
import useI18n from '@/composables/use-i18n'

export default defineComponent({
  props: {
    value: {
      type: Boolean as PropType<boolean | null>,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const i18n = useI18n()
    const {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clear,
    } = useFilterBarItem(toRefs(props).value, emit)

    const clickSave = () => {
      saveAndHide()

      tdCarFilterPc({
        license: selected.value ? i18n.t('filter.acceptForeigner.switch.label').toString() : '',
      })
    }

    const selected = ref(props.value)
    const onUpdate = (value: boolean) => {
      selected.value = value
    }

    return {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clear,
      clickSave,

      onUpdate,
    }
  },
})
